import axios from "axios"
import { baseUrlApi } from "./Api"

export default {

  getCompanies() {
    const url = `${baseUrlApi}/get-companies`;
    return axios.get(url);
  },

  postCompanyById(form) {
    const url = `${baseUrlApi}/post-company-public-from`;
    return axios.post(url, form);
  },

  postCompany(companyId) {
    const url = `${baseUrlApi}/post-company/${companyId}`;
    return axios.post(url);
  },

  getFormsField() {
    const url = `${baseUrlApi}/get-forms-field`;
    return axios.get(url);
  },

  posCreateCompany(form) {
    const url = `${baseUrlApi}/post-create-company`;
    return axios.post(url, form);
  },

  putUpdateCompany(companyId, form) {
    const url = `${baseUrlApi}/put-update-company/${companyId}`;
    return axios.put(url, form);
  },
};

